import { callGet, callPost } from '../axios'

export const getAdminActivity = async (searchText = '', page, limit, startDate, endDate) => {
  const token = JSON.parse(localStorage.getItem('token'))
  return callGet('/adminActivity.php', token, { type: 'getAdminActivity', searchText, page, limit, startDate, endDate })
    .then((res) => res?.data?.data)
    .catch((err) => Promise.reject(err))
}

export const trackAdminVisit = async (pageUrl) => {
  const token = JSON.parse(localStorage.getItem('token'))
  if (!token || !pageUrl) {
    return null
  }
  const formData = new FormData()
  formData.append('type', 'trackAdminVisit')
  formData.append('pageUrl', pageUrl)
  return callPost('/adminActivity.php', formData, token).catch(() => null)
}

